import React, { Component } from 'react';
import { SideNavigation, TopNavigation } from './';
import './pageTemplate.scss';

export class PageTemplate extends Component {
    render() {
        const pageID = this.props.id || '';

        return (
            <div className="pageTemplate">
                <div className="rightSide">
                    <SideNavigation/>
                </div>
                <div className="leftSide">
                    <TopNavigation/>
                    <div className="pageChildren" id={pageID}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PageTemplate/PageTemplate.jsx